import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'
import {
	CouponCreationType,
	CouponDeletionType,
	CouponUpdatePathType,
	CouponUpdateType,
} from '@schemas'

export const getCoupon = async ({ customHeaders = {} } = {}): Promise<
	ResType | undefined
> => {
	try {
		const uri = '/coupon'
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const addCoupon = async ({
	body = {
		name: '',
		email: '',
		discountUsd: 0,
		quantity: 0,
		expiredAt: '',
		useYn: 0,
	} as CouponCreationType,
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/coupon'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const deleteCoupon = async ({
	params = { couponId: '' } as CouponDeletionType,
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/coupon/${params.couponId}`
		const req = new ApiRequest({
			method: 'delete',
			uri: uri,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const updateCoupon = async ({
	params = { couponId: '' } as CouponUpdatePathType,
	body = {
		name: '',
		email: '',
		discountUsd: 0,
		quantity: 0,
		expiredAt: '',
		useYn: 0,
	} as CouponUpdateType,
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/coupon/${params.couponId}`
		const req = new ApiRequest({
			method: 'put',
			uri: uri,
			body: body,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const getCouponApply = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/coupon/apply'
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
			isRequiredToken: false,
		})

		const result: ResType = await Api.connection(req)
		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

const couponApi = {
	getCoupon,
	addCoupon,
	deleteCoupon,
	updateCoupon,
	getCouponApply,
}

export default couponApi
